rhm.modernizr = (function (module) {
  'use strict';
  var validate;
  validate = function () {
    if (!Modernizr.objectfit) {
      document.querySelectorAll('figure .banner.cover').forEach(function (container) {
        var img = container.querySelector('img');
        var imgUrl = img && img.src;
        if (imgUrl) {
          container.style.backgroundImage = 'url(' + imgUrl + ')';
          container.classList.add('compat-object-fit');
        }
      });
    }
  };
  module = { validate: validate };
  return module;
})(rhm.modernizr);
